<template lang="pug">
  UndraggableRouterLink(:to="item.url").ListItem.ListItem-square.ListItem-light
    .ListItem_catchable()
    .ListItem_wrapper(ref='wrapper')
      .ListItem_bg
      .ListItem_content

        ItemIndex(:index="index")

        h3.ListItem_title
          TextAutoResize(:maxLines="4") {{ item.title }}

        .ListItem_sep
</template>

<script>

import ItemIndex from '@/components/common/ItemIndex'
import UndraggableRouterLink from '@/components/common/UndraggableRouterLink'
import mouseParallax from '@/mixins/mouseParallax'
import TextAutoResize from '@/components/common/TextAutoResize'

export default {
  props: ['index', 'item'],
  mixins: [ mouseParallax ],
  components: {
    ItemIndex,
    UndraggableRouterLink,
    TextAutoResize
  },
  mounted () {
    this.initMouseEvents()
  }
}

</script>
